import React from "react";
import { Trans } from "react-i18next";
import { Col, Row } from "reactstrap";

import "./mobileInfoBar.scss";

const MobileInfoBar = ({ bannerText }) => {
  return (
    <Row>
      <Col className={`mobile-info-bar color-${bannerText.color}`}>
        <Trans i18nKey={bannerText.translation}>{bannerText.default}</Trans>
      </Col>
    </Row>
  );
};
export default MobileInfoBar;
